import {connect} from 'react-redux';
import CheckoutRoster from './CheckoutRoster.jsx';

import {
  handleReviewCartClick,
  handleContinueShoppingSelection
} from './actions';

import {
  displayClearCartConfirmation
} from '../shared/actionTypes';

const mapStateToProps = state => ({
  ...state.registration.base,
  ...state.registration.payment,
  rostersComplete: state.registration.rostercheckout.rostersComplete,
  entries: state.registration.shared.entries,
  virtualEntries: state.registration.shared.virtualEntries,
  rosterMessage: state.registration.base.rosterMessage
});

const mapDispatchToProps = dispatch => ({
  onClearCartClick: () => dispatch(displayClearCartConfirmation(true)),
  onContinueShoppingClick: () => dispatch(handleContinueShoppingSelection()),
  onReviewClick: () => dispatch(handleReviewCartClick())
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutRoster);



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/CheckoutRosterContainer.jsx